import React from 'react';
import {NEITHER_IN_TAB_NOR_IN_ARROW_ORDER} from '../../hooks/useGroupedFocus.js';

export default function ProductCardSingleImage({item, onItemClick}) {

    const itemImageRoot = item.productImages ? item.productImages[0] : item.responsiveImage;

    const sources = itemImageRoot.imagePaths.map((path, index2) => {
        return (
            <source
                media={'(' + path.mediaQuery + ')'}
                srcSet={path.plainPath + ' 1x, ' + path.retinaPath + ' 2x'}
                key={index2}
            />
        );
    });

    return (
        <div className={`product-card_image-content-wrapper`}>
            <div className='product-card_image-wrapper'>
                <div className='product-card_image-container'>
                    <a href={item.productLink} onClick={onItemClick} className='product-card_image-link' tabIndex={NEITHER_IN_TAB_NOR_IN_ARROW_ORDER}>
                        <picture className={'product-card_image'}>
                            {sources}
                            <img
                                src={itemImageRoot.defaultImagePath}
                                alt={item.title + ' Bild'}
                            />
                        </picture>
                    </a>
                </div>
            </div>
        </div>
    )
}
